import type { IWorkingSite } from '@interfaces/IWorkingSite';

const KEY = 'dorca_working_site';

function safeRead(): IWorkingSite | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as IWorkingSite;
  } catch {
    return null;
  }
}

export const siteService = {
  getChosenSite(): IWorkingSite | null {
    return safeRead();
  },
  setChosenSite(site: IWorkingSite): void {
    try { localStorage.setItem(KEY, JSON.stringify(site)); } catch { /* ignore */ }
  },
  removeChosenSite(): void {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
  },
};
